module.exports = {"ronda-1":"Round 1","ronda-2":"Round 2","ronda-3":"Round 3","instrucciones":"Instructions"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locals/instructions/it.json
// module id = 185
// module chunks = 0